// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"dcedf81d","817":"7f838bd0"}[chunkId] + ".css";
};